import * as three from "three";
import ParticleMesh from "../../instancing/Meshes/ParticleMesh";
import AreaMesh from "../../instancing/Meshes/AreaMesh";
import RectangleMesh from "../../instancing/Meshes/RectangleMesh";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import createDiskTexture from "../../instancing/textures/createDiskTexture";

const pointSize = 8;
const size = 8;
const diskText = createDiskTexture({ size });

export function getShadowAreaMesh() {
  const conf = {
    posX: 1,
    posY: 1,
    rgbaCode: 1,
  };

  const colorMap = [
    new three.Vector4(0.6, 0.4, 0.8, 0.2), // default color
    new three.Vector4(1, 0, 0, 0), // hidden
  ];
  const matConf = { disableRaycast: true, transparent: true, antialias: true };
  const materialConf = getMaterialWithUniforms(matConf).setColorMap(colorMap);
  return new AreaMesh(materialConf, conf);
}

export function getReadsMesh() {
  const conf = {
    posX: 1,
    posY: 1,
    offset: 1,
    rgbaCode: 1,
  };
  const matconf = {
    transparent: true,
    depthTest: false,
    depthWrite: false,
    alphaTest: 0.1,
  };

  const materialConf = getMaterialWithUniforms(matconf)
    .setPointSize(pointSize)
    .setColorMap(Array(5).fill(new three.Vector4()))
    .setTexture(diskText.texture)
    .setTextureCoordMap(diskText.textureCoordsMap);

  return new ParticleMesh(materialConf, conf);
}
export function getReadBarMesh() {
  const conf = { posX: 1, rgbaCode: 1, posY: 1 };
  const colorMap = Array(1).fill(new three.Vector4(0.4, 0.2, 0.7, 0.2));
  const materialConf = getMaterialWithUniforms({})
    .setColorMap(colorMap)
    .setPaddingX([0, 0, 0, 0])
    .setPaddingY([-1, -1, 0, 0])
    .setOffset([0, 0]);

  return new RectangleMesh(materialConf, conf);
}

export function drawArea(items, mesh) {
  const count = items.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });
  for (let i = 0; i < count; i++) {
    const isFirst = i === 0;
    const isLast = i === count - 1;
    const rgbInd = isFirst || isLast ? 1 : 0;
    const x = items[i].region.g0 + items[i].region.size / 2;
    setX(i, x, x);
    setRgb(i, rgbInd, rgbInd);
  }
}

export function updateArea(items, mesh) {
  const { length: count } = items;
  const setY = mesh.updateY({ count, isAppend: false });
  for (let i = 0; i < count; i++) {
    const { min, max } = items[i];
    setY(i, max, min);
  }
}

export function drawRead(reads, mesh) {
  const count = reads.length;
  const isAppend = true;

  const setX = mesh.updateX({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });

  for (let i = 0; i < count; i++) {
    const { region, isOut } = reads[i];
    setX(i, region.g0 + region.size / 2);
    setRgb(i, isOut ? 4 : 0);
  }
}

export function drawReadBar(reads, mesh) {
  const count = reads.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });
  for (let i = 0; i < count; i++) {
    const { region, isOut } = reads[i];
    const { g0, g1 } = region;
    const rgb = isOut ? 4 : 0;
    setX(i, g0, g1, g0, g1);
    setRgb(i, rgb, rgb, rgb, rgb);
  }
}

export function updateRead(items, mesh) {
  const setY = mesh.updateY({ count: items.length, isAppend: false });
  for (let i = 0; i < items.length; i++) {
    const y = items[i].readratio;
    setY(i, y, y, y, y);
  }
}
